import { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ManagersDrawer from 'components/Managers/Drawer/Drawer';
import ManagersList from 'components/Managers/List/List';
import ManagerDetails from 'components/Managers/Details/Details';
import useCustomSelector from 'hooks/useCustomSelector';
import { managersSelectors } from 'features/managers';

const Managers = () => {
  const { id } = useCustomSelector(managersSelectors.getManagerData);

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <ManagersDrawer />
      <ManagersList />
      {!!!id ? <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant='h5'>Please select user...</Typography>
      </Box> :  <ManagerDetails /> }
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Managers {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);